import DOMPurify from "dompurify";

const QUILL_ALLOWED_TAGS = [
  "a",
  "blockquote",
  "br",
  "code",
  "em",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "li",
  "ol",
  "p",
  "pre",
  "s",
  "span",
  "strong",
  "sub",
  "sup",
  "u",
  "ul",
];

export const RICH_TEXT_SANITIZE_CONFIG = Object.freeze({
  ALLOWED_TAGS: QUILL_ALLOWED_TAGS,
  ALLOWED_ATTR: ["class", "href", "rel", "target"],
  ALLOW_DATA_ATTR: false,
});

export function sanitizeRichText(html) {
  return DOMPurify.sanitize(String(html || ""), RICH_TEXT_SANITIZE_CONFIG);
}
